var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filters" },
    [
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "control has-icons-left" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.filterBy,
                expression: "filterBy",
              },
            ],
            staticClass: "input",
            attrs: { type: "search", placeholder: "Filter" },
            domProps: { value: _vm.filterBy },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.filterBy = $event.target.value
              },
            },
          }),
          _vm._m(0),
        ]),
      ]),
      _c("field-checkbox", { on: { change: _vm.updateSort } }, [
        _vm._v("Display as A-Z list"),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon is-left" }, [
      _c("i", { staticClass: "fas fa-search" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }